import script from "./ModalBodyProductItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBodyProductItem.vue?vue&type=script&setup=true&lang=js"

import "./ModalBodyProductItem.vue?vue&type=style&index=0&id=c4c9519c&lang=scss&scoped=true"

import exportComponent from "/var/www/rayband/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4c9519c"]])

export default __exports__